import { z } from 'zod';
import { BpfCloseReasonType } from '../../types';

export const CloseReasonSchema = z.object({
  id: z.string().uuid(),
  isActive: z.boolean(),
  flowId: z.string().uuid(),
  createdDateTime: z.string(),
  label: z.string().min(3),
  type: z.nativeEnum(BpfCloseReasonType),
  modifiedDateTime: z.string().nullable(),
});
